import axios from 'axios'
import { keycloakService } from '@/services/keycloak-service'
import { configureScope } from '@sentry/browser'
import uuid from 'uuid'
import { isNotAuthorize } from '@/helpers/request-helper'
import { MyActiveOrganization } from '@/helpers/my-account-helper'

export const coreApiPath = '/api'
export const clinicalApiPath = '/clinical'

export let viperApi = axios.create()

export function configureApiTokenInterceptor() {
  viperApi = axios.create({
    baseURL: window.$appConfig.VUE_APP_VIPER_API_BASE_URL + coreApiPath,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  viperApi.interceptors.request.use(
    config => {
      const transactionId = uuid()
      configureScope(s => s.setTag('transaction_id', transactionId))
      config.headers.Authorization = `Bearer ${keycloakService.getToken()}`
      config.headers['X-Transaction-ID'] = transactionId
      if (MyActiveOrganization && MyActiveOrganization.id) {
        config.headers['X-Tenant-ID'] = MyActiveOrganization.id
      }
      return config
    },
    error => Promise.reject(error)
  )

  viperApi.interceptors.response.use(
    r => r,
    e => {
      if (axios.isCancel(e)) throw e
      if (isNotAuthorize(e.response)) {
        if (!e.response.config.url.endsWith('my-account')) {
          // temporary workaround for the my-account boot-off issue
          keycloakService.logout()
        } else {
          throw e
        }
      }
      return e
    }
  )
}
